import React, { useState } from 'react';
import "./Home4.css"
import Title from '../_title/Title'




const Home4 = ({ onButtonClick, galleryTitle="Gallery" }) => {



  return (
    <div className='home-4-main-container-1'>
        <div className="home-4-sub-container-2">
          {/* <Title title="OUR VISION:"/> */}
          <h1>Impacting the next Generation</h1>
          <h2>Empowering younger generations through diverse educational events and platforms, EduZolve creates opportunities for learning, growth, and skill development.</h2>
        </div>
    </div>
  )
}

export default Home4


